module.exports = __webpack_public_path__ + "static/DingGo-Logo-0423d6822c2380529858b94ae3ae06e7.png";